import _ from 'lodash';
import { stringify } from 'qs';
import { onboardingStatuses } from '../constants/general';

const privateResidenceLabelEn = 'Private Residence';

/**
 * @param {object} data
 * @return {object}
 * */
export function extractIndividualContactData ({ address, city, state, zip, address_coordinates, is_cc_exempt }) {
  return { address, city, state, zip, address_coordinates, is_cc_exempt };
}

/**
 * @param {object} data
 * @param {array} locationTypes
 * @return {object}
 * */
export function extractContactLocationData ({ address, city, state, zip, address_coordinates, company_id }, locationTypes) {
  const job_location_type_id = locationTypes.find(location => location.label_en === privateResidenceLabelEn).id;

  return { address, city, state, zip, coordinates: address_coordinates, company_id, job_location_type_id, location_name: privateResidenceLabelEn };
}

/**
 * @param {object} data
 * @return {object}
 * */
export function extractCompanyContactData ({ company_id, department_id }) {
  return ({ company_id, department_id });
}

/**
 * @param {object} data
 * @return {object}
 * */
export function extractContactData (data) {
  const { first_name, last_name, email, phone, password, temp_password, language_id } = data;
  const initialData = { first_name, last_name, email, phone, password, temp_password, language_id, onboarding_status: onboardingStatuses.ONBOARD_COMPLETED };
  const userInputData = data.is_company ? extractCompanyContactData(data) : data;

  return Object.assign(initialData, userInputData);
}

const allowedFilterParams = ['full_name'];

/**
 * @param {object} filterData
 * @return {object}
 */
export function setContactsFilterParams (filterData) {
  let filterParams = {};

  for (let key in filterData) {
    if (allowedFilterParams.includes(key)) {
      const filterParam = filterData[key];

      if (_.isString(filterParam) && filterParam.length) {
        filterParams[key] = filterParam;
      }
    }
  }

  const queryString = !_.isEmpty(filterParams) ? `&${stringify(filterParams)}` : '';

  return ({ queryString, urlString: queryString });
}



// WEBPACK FOOTER //
// ./src/helpers/contacts.js